import { createContext, useContext, useEffect } from "react";

const SetRedemptionPresentationBlockerContext = createContext<
  (key: string, active: boolean) => void
>(() => undefined);

export const RedemptionPresentationProvider =
  SetRedemptionPresentationBlockerContext.Provider;

export function useRedemptionPresentationBlocker(
  key: string,
  active: boolean,
) {
  const setBlockerActive = useContext(
    SetRedemptionPresentationBlockerContext,
  );

  useEffect(() => {
    setBlockerActive(key, active);
    return () => setBlockerActive(key, false);
  }, [active, key, setBlockerActive]);
}
